<script>
// https://vuematerial.io/ui-elements/elevation
// https://vuematerial.io/components/content
// https://vuematerial.io/ui-elements/scrollbar

export default {
    name: 'dkbr-frame',
    props: {
        th: {
            name: 'th',
            type: String,
            enum: ['th1', 'th2', 'th3', 'th4', 'th5', 'th6', 'th7'],
            txtDescr: `Color theme of the element`,
            default: _ => 'th1',
        },
        isThInv: {
            name: 'isThInv',
            type: Boolean,
            txtDescr: `If is true, inversed color theme will be used`,
            default: _ => false,
        },
        tag: {
            name: 'tag',
            type: String,
            txtDescr: `Html tag for resulting element`,
            default: _ => 'div',
        },
        elevation: {
            name: 'elevation',
            type: Number,
            txtDescr: `Elevation (0..24)`,
            validator: v => v >= 0 && v <= 24,
            default: _ => 0,
        },
        isScrollbar: {
            name: 'isScrollbar',
            type: Boolean,
            txtDescr: `If is true, scroll will be presented`,
            default: _ => false,
        },
        w: {
            name: 'Width',
            type: Number,
            txtDescr: `Width of the frame (in pixels)`,
            validator: v => v >= 0,
            default: _ => 0,
        },
        h: {
            name: 'Height',
            type: Number,
            txtDescr: `Height of the frame (in pixels)`,
            validator: v => v >= 0,
            default: _ => 0,
        },
        m: {
            name: 'Margin',
            type: Number,
            txtDescr: `Margin for the frame (in pixels)`,
            validator: v => v >= 0,
            default: _ => 0,
        },
        p: {
            name: 'Padding',
            type: Number,
            txtDescr: `Padding for the frame (in pixels)`,
            validator: v => v >= 0,
            default: _ => 0,
        },
        colorBg: {
            name: 'Color (bg)',
            type: String,
            txtDescr: `Color of the frame background`,
            validator: v => true,
            default: _ => undefined,
        },
        colorFg: {
            name: 'Color (fg)',
            type: String,
            txtDescr: `Color of the frame foreground (text)`,
            validator: v => true,
            default: _ => undefined,
        }
    }
}
</script>

<template lang="pug">

md-content(
    :md-tag="tag"
    :md-theme="isThInv ? th+'i' : th"
    :style=`{
        width: w ? w + 'px' : undefined,
        height: h ? h + 'px' : undefined,
        margin: m ? m + 'px' : undefined,
        padding: p ? p + 'px' : undefined,
        backgroundColor: colorBg,
        color: colorFg,
    }`
    :class=`[
        'md-primary',
        elevation ? 'md-elevation-'+elevation : undefined,
        {'md-scrollbar': isScrollbar,}
    ]`)
    slot
</template>



// WEBPACK FOOTER //
// src/frame/vue/Frame.vue